import React from 'react';
import './FoundWords.css';

interface FoundWordsProps {
  words: string[];
}

const FoundWords: React.FC<FoundWordsProps> = ({ words }) => {
  return (
    <div className="found-words-container">
      <h3 className="found-words-title">✅ Found Words</h3>
      <div className="found-words-list">
        {words.length === 0 ? (
          <p className="found-words-hint">Find words to see them here!</p>
        ) : (
          words.map((word, index) => (
            <span key={index} className="found-word" style={{ animationDelay: `${index * 0.05}s` }}>
              {word}
            </span>
          ))
        )}
      </div>
    </div>
  );
};

export default FoundWords;
